import React, { createContext, useContext, useState } from 'react';
import { api } from 'app';

const UsersUIContext = createContext();

export function useUsersUIContext() {
  return useContext(UsersUIContext);
}

export function UsersUIProvider({ children }) {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);

  const fetchData = async input => {
    const query = input ? input.slice(1) : '';
    api
      .get(`/adminPanel/users?${query}`)
      .then(response => {
        setData(response);
      })
      .catch(err => {
        console.log(err);
      });
  };

  const value = {
    fetchData,
    data,
    setData,
    isLoading,
    setIsLoading
  };

  return <UsersUIContext.Provider value={value}>{children}</UsersUIContext.Provider>;
}
